export default __webpack_public_path__ + "static/media/slack_dark.7650930f.svg";